<template>
  <div>
    <a-button type="primary" @click="getList">
      {{ $t('refresh') }}
    </a-button>
    <a-table :columns="columns" :data-source="data">
      <span slot="action" slot-scope="text, record">
      <a-popconfirm
          title="确定剔除该节点吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirmRemoteNode(record.userName)"
      >
        <a-button type="link">剔除</a-button>
      </a-popconfirm>

    </span>
    </a-table>
  </div>
</template>

<script>
import {
  NodeServiceProxy,
  OfflineNodeDto
} from "@/service-proxies/app-v2/iot-remoteterminal-v2.service-proxies";
import dayjs from "dayjs";
const escp = new NodeServiceProxy();

export default {
  name: "WebNode",
  data() {
    return {
      data:[],
      columns: [
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          width: 100,
        },

        {
          title: '用户',
          dataIndex: 'userName',
          key: 'userName',
          width: 100,
        },
        {
          title: '网关编号',
          dataIndex: 'gatewayCode',
          key: 'gatewayCode',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          width: 100,
        },
        {
          title: '登录时间',
          dataIndex: 'utcLoginTime',
          key: 'utcLoginTime',
          scopedSlots: {
            customRender: 'utcLoginTime'
          },
          width: 100,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        }
      ]
    }
  },
  props: {

  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      escp.findWebNodeList().then(res => {
        if (res){
          this.data = res.data
        }
      })
    },
    confirmRemoteNode(nodeId){
      let dto = new OfflineNodeDto()
      dto.nodeId = nodeId
      escp.offlineWebNode(dto).then((res) =>{
        this.getList()
      })
    }
  }
}
</script>

<style scoped>

</style>